export interface MotionSettings {
  enableAnimations: boolean;
  inViewOnce: boolean;
  inViewAmount: number;
  projectCardHover: {
    y: number;
    scale: number;
  };
  projectImageFloat: {
    y: number;
  };
}

export const motionConfig: MotionSettings = {
  enableAnimations: true,
  inViewOnce: true,
  inViewAmount: 0.1,
  projectCardHover: {
    y: -4,
    scale: 1.02,
  },
  projectImageFloat: {
    y: 20,
  },
};
